var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodCyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.79,
    height: 94.5,
    viewBox: "0 0 222.79 94.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pod-cyan",
    transform: "translate(-1.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48858",
    "data-name": "Group 48858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52461",
    "data-name": "Path 52461",
    d: "M163,76.8c-2,2.3-5.1,3.4-9.2,3.4a17.733,17.733,0,0,1-2.2-.1c-.8-.1-1.8-.2-2.7-.3V89a.908.908,0,0,1-.3.7,1.08,1.08,0,0,1-.7.3H143a.908.908,0,0,1-.7-.3,1.08,1.08,0,0,1-.3-.7V53.2c0-.4.1-.7.3-.8a2.257,2.257,0,0,1,1.1-.5c1.6-.4,3.3-.7,5.2-1a32.819,32.819,0,0,1,5.2-.4c4.1,0,7.3,1.1,9.2,3.4,2,2.3,3,5.4,3,9.5v4C166,71.3,165,74.5,163,76.8Zm-3.8-13.5a26.419,26.419,0,0,0-.2-2.9,6.9,6.9,0,0,0-.8-2.3,4.978,4.978,0,0,0-1.7-1.5,5.4,5.4,0,0,0-2.7-.6c-.9,0-1.9.1-2.8.1a20.579,20.579,0,0,0-2.1.3V74.3c.7.1,1.6.2,2.6.3a22.749,22.749,0,0,0,2.4.1,5.4,5.4,0,0,0,2.7-.6,4.978,4.978,0,0,0,1.7-1.5,5.231,5.231,0,0,0,.8-2.3,26.415,26.415,0,0,0,.2-2.9V63.3Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52462",
    "data-name": "Path 52462",
    d: "M194.6,72.5a9.54,9.54,0,0,1-2.4,4,11.871,11.871,0,0,1-3.8,2.7,14.3,14.3,0,0,1-5.3,1,12.538,12.538,0,0,1-5.3-1,10.516,10.516,0,0,1-3.8-2.7,13.313,13.313,0,0,1-2.4-4,17.015,17.015,0,0,1-.8-5.1V63.2a16.522,16.522,0,0,1,.8-5.1,9.54,9.54,0,0,1,2.4-4,11.871,11.871,0,0,1,3.8-2.7,14.545,14.545,0,0,1,10.6,0,10.516,10.516,0,0,1,3.8,2.7,13.313,13.313,0,0,1,2.4,4,17.015,17.015,0,0,1,.8,5.1v4.2A16.522,16.522,0,0,1,194.6,72.5Zm-6-9.3a8.791,8.791,0,0,0-1.4-5.1,5.374,5.374,0,0,0-8.2,0,8.572,8.572,0,0,0-1.4,5.1v4.2a8.791,8.791,0,0,0,1.4,5.1,5.374,5.374,0,0,0,8.2,0,8.572,8.572,0,0,0,1.4-5.1Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52463",
    "data-name": "Path 52463",
    d: "M224,78.3a2.257,2.257,0,0,1-1.1.5c-1.6.4-3.3.7-5.2,1a31.97,31.97,0,0,1-5.2.4c-4.1,0-7.3-1.1-9.2-3.4-2-2.3-3-5.4-3-9.5V63.4c0-4,1-7.2,3-9.5s5.1-3.4,9.2-3.4a17.733,17.733,0,0,1,2.2.1c.8.1,1.8.2,2.7.3V41.8a.908.908,0,0,1,.3-.7,1.08,1.08,0,0,1,.7-.3h4.8a.908.908,0,0,1,.7.3,1.08,1.08,0,0,1,.3.7V77.6A1.165,1.165,0,0,1,224,78.3Zm-6.5-21.9c-.7-.1-1.6-.2-2.6-.3a22.749,22.749,0,0,0-2.4-.1,5.4,5.4,0,0,0-2.7.6,4.978,4.978,0,0,0-1.7,1.5,5.231,5.231,0,0,0-.8,2.3,13.678,13.678,0,0,0-.2,2.9v3.9a26.419,26.419,0,0,0,.2,2.9,6.9,6.9,0,0,0,.8,2.3,4.978,4.978,0,0,0,1.7,1.5,5.4,5.4,0,0,0,2.7.6c.9,0,1.9-.1,2.8-.1a20.576,20.576,0,0,0,2.1-.3V56.4Z",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48861",
    "data-name": "Group 48861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48859",
    "data-name": "Group 48859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52464",
    "data-name": "Path 52464",
    d: "M90,33.5h0a46.455,46.455,0,0,1,11.7-5.4c4.1-1.4,8.7-3.2,13.5-5.2,3.5-1.6,7.2-3.2,10.7-4.8,11.4-5.5,21.9-11.7,25.2-16.5a4.385,4.385,0,0,0,.5-.9c.1-.1.1-.2.2-.3h0a8.648,8.648,0,0,1-.6,4.2,23.949,23.949,0,0,1-5,6.5C138.3,18,126.6,24.4,109.6,32s-25,12.5-27.5,17C82.1,49.1,81.7,38.4,90,33.5Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52465",
    "data-name": "Path 52465",
    d: "M80.3,65.3l.5-1.9c3-7.4,18.7-14.6,43-29.2,4.3-2.6,7.9-5,11.1-7.2h0l.1-.1c8.3-5.9,12.8-10.5,15.2-13.6a14.625,14.625,0,0,0,.9-1.3,25.5,25.5,0,0,0,1.8-3.1,13.866,13.866,0,0,0,1.3-7.5v.1a5.877,5.877,0,0,0-.3-1.4c0,16.3-44.2,35-59.7,42.5-6.1,2.9-9.5,5.8-11.4,8.2h0c-2.9,2.8-3.9,9.2-2.9,13.1A2.359,2.359,0,0,0,80.3,65.3Zm59.8-45.9Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52466",
    "data-name": "Path 52466",
    d: "M81.1,81.7c-.4-10.9,22.5-24,42.4-37.5,4.7-3.1,14.1-9.9,20-16.6,6.9-7.8,7.8-13.3,7.8-13.3s-.6.9-2.7,3.7a73.761,73.761,0,0,1-7.4,7.1,60.693,60.693,0,0,1-5.5,4.3c-10.2,7.6-23.8,16-37.4,23.5-9.9,5.4-14.6,10-16.8,13.6h0c-3.2,4.7-1.8,11-.9,13.7A5.108,5.108,0,0,0,81.1,81.7Zm46.8-45.4Zm20.2-17.6c-.5.6-1.2,1.4-2,2.2C146.8,20.1,147.5,19.3,148.1,18.7Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52467",
    "data-name": "Path 52467",
    d: "M143.1,30.8s-.9,5.5-13.4,16.1C116.5,58.1,84.2,78.5,85.9,94.5c0,0-9.3-9.6,1.4-20.2,5.1-5,17.2-13.4,29.2-21.9C129.6,43.2,141.6,34,143.1,30.8Z",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48860",
    "data-name": "Group 48860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52468",
    "data-name": "Path 52468",
    d: "M65.6,33.5h0a46.455,46.455,0,0,0-11.7-5.4c-4.1-1.4-8.7-3.2-13.5-5.2-3.5-1.6-7.2-3.2-10.7-4.8C18.2,12.6,7.8,6.4,4.5,1.6A6.782,6.782,0,0,1,3.9.7c0-.1-.1-.2-.1-.3h0a8.648,8.648,0,0,0,.6,4.2,23.948,23.948,0,0,0,5,6.5C17.3,18,29,24.4,46,32S71,44.5,73.5,49C73.4,49.1,73.9,38.4,65.6,33.5Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52469",
    "data-name": "Path 52469",
    d: "M75.8,63.8c.9-3.9-.1-10.2-2.9-13.1h0c-1.9-2.4-5.3-5.3-11.4-8.2C46,35,1.8,16.3,1.8,0a2.908,2.908,0,0,0-.3,1.4h0A13.809,13.809,0,0,0,2.8,8.9,10.929,10.929,0,0,0,4.6,12a14.629,14.629,0,0,1,.9,1.3c2.4,3.1,6.9,7.7,15.2,13.6l.1.1h0c3.1,2.2,6.8,4.7,11.1,7.2,24.3,14.6,40,21.8,43,29.2l.5,1.9A9.476,9.476,0,0,0,75.8,63.8ZM15.5,19.4Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52470",
    "data-name": "Path 52470",
    d: "M75,80.2c.9-2.8,2.3-9.1-.9-13.7h0c-2.2-3.5-6.9-8.1-16.8-13.6C43.7,45.4,30,37,19.8,29.4c-.1-.1-2.7-2-5.5-4.3A64.072,64.072,0,0,1,6.9,18c-2.1-2.8-2.7-3.7-2.7-3.7s.9,5.5,7.8,13.3c5.9,6.6,15.3,13.5,20,16.6C52,57.6,74.9,70.8,74.5,81.7A5.108,5.108,0,0,0,75,80.2ZM27.7,36.3ZM9.6,20.9a18.081,18.081,0,0,1-2-2.2C8.1,19.3,8.8,20.1,9.6,20.9Z",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52471",
    "data-name": "Path 52471",
    d: "M12.5,30.8s.9,5.5,13.4,16.1C39.1,58.1,71.4,78.5,69.7,94.5c0,0,9.3-9.6-1.4-20.2C63.2,69.4,51,61,39.1,52.5,26,43.2,14,34,12.5,30.8Z",
    fill: "#3eb6fb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodCyan);
export default __webpack_public_path__ + "static/media/pod-cyan.057db7d270c6e34c2bde60b5969ca8ab.svg";
export { ForwardRef as ReactComponent };